/**
 * SuspendedPage — shown when a tenant is suspended (e.g. after Gitex cliff
 * without a saved card, or PAYG billing failure).
 *
 * Displays a message and links to choose a new plan.
 */

import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Layout from '../components/layout/Layout';
import { Button } from '@/components/ui/atoms/Button';

export const SuspendedPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  return (
    <Layout className="min-h-screen bg-background-gray flex flex-col" hideFooter>
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center">
          <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-6">
            <AlertTriangle className="w-7 h-7 text-amber-600" />
          </div>

          <h1 className="text-2xl font-bold text-[#171D27] mb-3">
            {t('errors.suspended_title')}
          </h1>

          <p className="text-[#4C4E51] mb-8">
            {t('errors.suspended_desc')}
          </p>

          <Button
            label={t('errors.choose_plan')}
            type="contained"
            intent="secondary"
            size="lg"
            className="w-full"
            onClick={() => navigate('/onboarding/pack-selection')}
          />
        </div>
      </main>
    </Layout>
  );
};

export default SuspendedPage;
